export default __webpack_public_path__ + "static/media/re-f9.f41fa766.svg";